//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
    name: 'share',
    props: ['text', 'qrcodeUrl', 'repayAmount', 'realName', 'isKoo'],
    data() {
        return {
            isScroll: false,
        }
    },
    components: {
        qrcode: VueQrcode
    },
    mounted() {

        const element = this.$refs.share
        this.isScroll = element.scrollHeight > element.clientHeight
    }
}
